var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664993 9.13557V3.84145C0.664993 2.999 1.02057 2.19105 1.65351 1.59535C2.28644 0.999641 3.14489 0.664978 4.03999 0.664978H15.29C16.1851 0.664978 17.0435 0.999641 17.6765 1.59535C18.3094 2.19105 18.665 2.999 18.665 3.84145V9.13557",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.664993 9.13556H4.03999M15.29 9.13556H18.665",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66499 6.62415C11.2002 6.62415 12.375 7.78622 12.375 9.13586C12.3748 10.4854 11.2001 11.6466 9.66499 11.6466C8.12985 11.6466 6.9552 10.4854 6.95503 9.13586C6.95503 7.78622 8.12975 6.62415 9.66499 6.62415Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66499 13.5065C11.256 13.5065 12.5237 13.8816 13.372 14.4518C14.2106 15.0155 14.625 15.7523 14.625 16.5475V17.9996H4.70503V16.5475C4.70503 15.7523 5.11937 15.0155 5.95796 14.4518C6.80629 13.8816 8.07398 13.5065 9.66499 13.5065Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadOutlined);
export default __webpack_public_path__ + "static/media/lead_outlined.7e765d8de6d540551937a443501ee9cd.svg";
export { ForwardRef as ReactComponent };